module.exports = __webpack_public_path__ + "static/media/YM66_3.54711659.jpg";